import { render } from "./PageLoading.vue?vue&type=template&id=e9bdea7e&scoped=true"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"

import "./PageLoading.vue?vue&type=style&index=0&id=e9bdea7e&scoped=true&lang=css"

import exportComponent from "F:\\work\\projects\\HiOmics\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9bdea7e"]])

export default __exports__